export default "__VITE_ASSET__Bl31Aai5__"